import { Overrides } from '@material-ui/core/styles/overrides'

import { greyMultibrandPalette, masmovilPalette, llamayaPalette } from './colors'

const commonLinearProgressOverride: Overrides = {
  MuiLinearProgress: {
    root: {
      height: '8px',
      borderRadius: '4px',
    },
    colorPrimary: {
      backgroundColor: greyMultibrandPalette[100],
    },
    barColorPrimary: {
      borderRadius: '100px',
    },
  },
}

export const masmovilLinearProgressOverride = {
  MuiLinearProgress: {
    ...commonLinearProgressOverride.MuiLinearProgress,
    barColorPrimary: {
      ...commonLinearProgressOverride.barColorPrimary,
      backgroundColor: masmovilPalette.success.light,
    },
  },
}

export const llamayaLinearProgressOverride = {
  MuiLinearProgress: {
    ...commonLinearProgressOverride.MuiLinearProgress,
    barColorPrimary: {
      ...commonLinearProgressOverride.barColorPrimary,
      backgroundColor: llamayaPalette.success.light,
    },
  },
}
